import { authApi } from "@/api/auth";

/** Query key factory for auth-related queries. */
export const authKeys = {
  all: ["auth"] as const,
  me: () => [...authKeys.all, "me"] as const,
};

/** Single source of truth for the session query configuration. */
export function sessionQueryOptions() {
  return {
    queryKey: authKeys.me(),
    queryFn: () => authApi.me(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  };
}
